import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formLabelsTheme,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStylesReddit,
  validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectCountry,
  selectParameter,
  selectParameter2,
  selectPhoneType,
} from "../businessParameter/businessParameterSlice";
// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { selectCountryAll } from "../location/locationSlice";
import { v4 as uuidv4 } from "uuid";

import { selectPagination } from "../../modules/Auth";
import {
  addReportIssue,
  editReportIssue,
  fetchReportIssue,
} from "./reportIssueSlice";
import { selectReasonCode } from "../miscellaneous/MiscellaneousSlice";
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ModalCreateReportIssue = ({
  isOpen,
  setShow,
  setFormValues,
  formValues,
  setFields,
  fields,
  row,
  setRow,
  id,
  showParty,
  setShowParty,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const dataClientRelated = useSelector(selectParameter2);
  const dataCountry = useSelector(selectCountryAll);
  const [get, setGet] = useState(false);
  const paginationSet = useSelector(selectPagination);
  const dataReason = useSelector(selectReasonCode);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleSave = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    const params = {
      vin: formValues.vin.value,
      issue_date: formValues.issue_date.value,
      remarks: formValues.hold_remarks.value,
      hold_reason: formValues.hold_reason.value,
    };

    // const paramsId = {
    //   reportissue_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   vin: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   inspection_result: "string",
    //   issue_date: "2023-10-19T11:48:18.964Z",
    //   remarks: "string",
    //   hold_reason: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   resolve_date: "2023-10-19T11:48:18.964Z",
    // };

    try {
      const response = await dispatch(addReportIssue(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);

        await handleClose();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleClose = () => {
    setFormValues({
      reportissue_id: {
        value: "",
        error: false,
        required: "N",
      },
      vin: {
        value: "",
        error: false,
        required: "Y",
      },
      issue_date: {
        value: "",
        error: false,
        required: "Y",
      },
      hold_reason: {
        value: "",
        error: false,
        required: "N",
      },
      hold_remarks: {
        value: "",
        error: false,
        required: "N",
      },
      resolve_date: {
        value: "",
        error: false,
        required: "N",
      },
      resolve_remarks: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setShow(false);
  };

  const reasonOptions = dataReason.map((e) => {
    return {
      value: e.reasoncode_id,
      label: e.reasoncode_code,
      name: e.reasoncode_name,
    };
  });

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Create Report Issue
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <RedditTextField
                  required
                  label="VIN"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="vin"
                  onChange={handleChange}
                  value={formValues.vin.value}
                  error={formValues.vin.error}
                  helperText={
                    formValues.vin.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {iconError} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                />

                <RedditTextField
                  required
                  label="Issue Date"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="issue_date"
                  type="datetime-local"
                  onChange={handleChange}
                  value={formValues.issue_date.value}
                  error={formValues.issue_date.error}
                  helperText={
                    formValues.issue_date.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {iconError} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                />
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                {" "}
                <Autocomplete
                  options={reasonOptions}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  getOptionName={(option) => option.name}
                  value={
                    reasonOptions.find(
                      (option) => option.value === formValues.hold_reason.value
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    console.log(newValue, "create");
                    if (newValue === null) {
                      setFormValues({
                        ...formValues,
                        ["hold_reason"]: {
                          ...formValues["hold_reason"],
                          value: "",
                        },
                        ["hold_remarks"]: {
                          ...formValues["hold_remarks"],
                          value: "",
                        },
                      });
                    } else {
                      setFormValues({
                        ...formValues,
                        ["hold_reason"]: {
                          ...formValues["hold_reason"],
                          value: newValue.value,
                        },
                        ["hold_remarks"]: {
                          ...formValues["hold_remarks"],
                          value: newValue.name,
                        },
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <RedditTextField
                      required
                      className={classes.margin}
                      {...params}
                      label="Hold Reason"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      placeholder="Select"
                      name="hold_reason"
                      value={formValues.hold_reason.value}
                      error={formValues.hold_reason.error}
                      helperText={
                        formValues.hold_reason.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  )}
                />
                <RedditTextField
                  label="Remarks"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  // multiline
                  // rows="4"
                  name="hold_remarks"
                  onChange={handleChange}
                  value={formValues.hold_remarks.value}
                />
              </Col>
            </Row>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleSave} variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
